import * as React from 'react';

import waveIcon from './assets/wave.image.svg';

import * as styles from './MarkdownHR.module.css';

const MarkdownHR = (props: any) => (
  <div className={styles.root} role="separator" {...props}>
    <img
      src={waveIcon}
      alt="火星の風切り音を表現する電波"
      aria-hidden
      className="ariaHidden"
      loading="lazy"
    />
  </div>
);

export { MarkdownHR };
